<template>
  <v-container>
    <v-card color="primary" class="rounded-xxl py-16 px-10">
      <v-card class="pt-7 pb-16" color="#fff">
        <toolbar-box :ids="ids" :filterSearch="filterSearch" @getData="getData" @clearIdList="clearIdList"/>

        <dataTable :ids="ids" :filterSearch="filterSearch" :items="items" :loading="loading" :totalPages="totalPages"
                   @getData="getData"
                   @updateIds="updateIds"/>

      </v-card>
    </v-card>
  </v-container>
</template>
<script>
import toolbarBox from "@/components/Courses/Course/filter.vue"
import dataTable from "@/components/Courses/Course/table.vue"
import courseApi from "@/Services/modules/courses"

export default {
  name: "listView",
  components: {toolbarBox, dataTable},
  data() {
    return {
      filterSearch: {
        page: Number(this.$route.query.page) || 1,
        is_archive: false,
        category_type__ne: "In_Person"
      },
      loading: false,
      ids: [],
      items: [],
      totalPages: 1,
    };
  },
  mounted() {
    this.getData(this.filterSearch)
  },
  methods: {
    getData(searchParams) {
      this.loading = true
      const params = { ...searchParams, category_type__ne: "In_Person" }
      courseApi.getAllBaseCourse(params).then((res) => {
        this.items = (res.data.results || []).filter(item => {
        const catType = item.category_type ?? item.category_data?.category_type
        return catType !== "In_Person"
      })
        this.totalPages = res.data.page_count
        this.ids = []
      }).catch((err) => {
        console.log(err)
      }).finally(() => {
        this.loading = false
      })
    },
    clearIdList() {
      this.ids = []
    },
    updateIds(ids) {
      this.ids = ids
    }
  },
}
</script>
